// Get parameter for el-edit-mode component

export default function getParameter (etudeData, theme, name, defaultValue) {
	if (
		etudeData.parameters[theme] &&
        etudeData.parameters[theme][name]
	) {
		return etudeData.parameters[theme][name];
	}

	return defaultValue;
}